import PartnerDetailsRequest from "../../api/raily/partner/details/partner-details.request";
import partnerApiService from "../../api/raily/partner/partner-api.service";
import dataLoadErrorFactory from "../../utils/data-load-error/data-load-error.factory";
import handleErrorFactory from "../../utils/handle-error/handle-error.factory";
import HttpError from "../../utils/http/http.error";
import PartnerDetails from "./details/partner-details";
import PartnerDetailsError from "./details/partner-details-error";
import PartnerDetailsParams from "./details/partner-details-params";
import partnerDetailsParamsFactory from "./details/partner-details-params.factory";
import partnerDetailsFactory from "./details/partner-details.factory";

const getDetails = async (
  params: PartnerDetailsParams,
  abortSignal: AbortSignal,
): Promise<PartnerDetails> => {
  const request: PartnerDetailsRequest =
    partnerDetailsParamsFactory.create(params);

  try {
    const response = await partnerApiService().getDetails(request, abortSignal);

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    const partnerDetails = partnerDetailsFactory.create(response);
    return partnerDetails;
  } catch (_error) {
    const error = _error as HttpError | PartnerDetailsError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const partnerService = {
  getDetails,
};

export default partnerService;
